import { Row } from "@amzn/stencil-react-components/layout";
import IconCheckCircleFill from "@amzn/stencil-react-icons/icons/icon-check-circle-fill";
import { IconSize } from "@amzn/stencil-react-icons/icons/interfaces";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FunctionComponent } from "react";

const EXTRA_DAYS = 1;

export interface EtaStatusIndicatorProps {
  etaDays: number;
  hasStock: boolean;
  size: IconSize;
}

export const EtaStatusIndicator: FunctionComponent<EtaStatusIndicatorProps> = ({ etaDays, hasStock, size }) => {
  if (hasStock === true || etaDays == 0) {
    return (
      <Row gridGap="S300" alignItems="center">
        <IconCheckCircleFill color="green70" size={size} />
        <strong>{getString("eta.statusIndicator.available")}</strong>
      </Row>
    );
  }
  const daysRange = `${etaDays}-${etaDays + EXTRA_DAYS}`;
  return (
    <Row gridGap="S300">
      <strong>{getString("eta.statusIndicator.wait", { daysRange })}</strong>
    </Row>
  );
};
